import { DATE, formatDateUTC } from '@utils/date';
import { SelectFactory } from '@g17eco/molecules/select/SelectFactory';
import { MinimalSurveyData } from './types';
import { OnChangeValue } from 'react-select';
import { Option, SelectTypes } from '../../../../molecules/select/types';
import './AssessmentDropdown.scss';
import { getAssessmentIcon } from '@apps/materiality-tracker/utils';

interface Props {
  selectedSurvey: Pick<MinimalSurveyData, '_id' | 'assessmentType' | 'payment' | 'effectiveDate'>;
  surveys: MinimalSurveyData[];
  onClickItem: (item: OnChangeValue<Option<string>, false>) => void;
}

export const AssessmentDropdown = (props: Props) => {
  const { selectedSurvey, surveys, onClickItem } = props;

  const options: Option<string>[] = surveys.map((survey) => ({
    value: survey._id,
    label: (
      <>
        <i className={`${getAssessmentIcon({ survey, ignorePaymentStatus: false })} mr-2`} />
        {formatDateUTC(survey.effectiveDate, DATE.YEAR_MONTH)}
      </>
    ),
  }));

  const getFormattedOption = () => {
    const selectedOption = options.find((op) => op.value === selectedSurvey._id);
    if (!selectedOption) {
      return null;
    }
    return {
      label: (
        <span className='formatted-option'>
          <i className={`${getAssessmentIcon({ survey: selectedSurvey })} mr-2`} />
          {formatDateUTC(selectedSurvey.effectiveDate, DATE.YEAR_MONTH)}
        </span>
      ),
      value: selectedOption?.value,
    };
  };

  return (
    <SelectFactory
      selectType={SelectTypes.SingleSelect}
      options={options}
      value={getFormattedOption()}
      onChange={onClickItem}
      isSearchable={false}
      isTransparent
    />
  );
};
